import { GetStravaMeasurementSystemQuery } from '../../../types/__generated__';
import getStravaMeasurementSystem from '../../components/Timeline/StravaTimelineEntry/GetStravaMeasurementSystem.gql';
import { getMeasurementSystemFromSettings } from '../../utils/measurementSystem';
import { useFullPageQuery } from '../index';

export function useMeasurementSystem() {
  const { data } = useFullPageQuery<GetStravaMeasurementSystemQuery>(
    getStravaMeasurementSystem,
  );

  const settings = data?.page?.strava?.settings;

  return getMeasurementSystemFromSettings(settings);
}
